// extracted by mini-css-extract-plugin
export default {"page":"MLyyk","content":"DBB72","infoConsent":"RQAZI"};